import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MEDIA } from "@/lib/constants";

export const Hero = ({ onApply }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero}
          alt="Athlete training in a dark gym"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#E63946]" />
            <span className="text-xs uppercase tracking-[0.3em] text-neutral-300">
              Online Fitness Coach
            </span>
          </div>

          <h1 className="font-heading font-black uppercase leading-[0.92] tracking-tighter text-5xl sm:text-6xl lg:text-7xl">
            Crush the Plateau.
            <br />
            <span className="text-[#E63946]">Build the Muscle.</span>
          </h1>

          <p className="mt-7 text-base lg:text-lg text-neutral-300 max-w-xl leading-relaxed">
            I help men who hit the wall break through their limits and transform
            their physique with the proven{" "}
            <span className="text-white font-semibold">Phase Forward Method</span>.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              onClick={onApply}
              data-testid="hero-primary-cta"
              className="group inline-flex items-center justify-center gap-2 bg-[#E63946] hover:bg-[#D90429] text-white font-heading font-bold uppercase tracking-wide text-base px-8 py-4 transition-all hover:scale-[1.03]"
            >
              Apply for Coaching
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="#method"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white text-white font-heading font-bold uppercase tracking-wide text-base px-8 py-4 transition-colors"
            >
              See the Method
            </a>
          </div>

          <div className="mt-14 flex items-center gap-8">
            {[
              { n: "100+", l: "Plateaus Broken" },
              { n: "1-on-1", l: "Personal Coaching" },
              { n: "12wk", l: "Transformation" },
            ].map((s) => (
              <div key={s.l} data-testid={`hero-stat-${s.l}`}>
                <div className="font-heading text-3xl font-black text-white">{s.n}</div>
                <div className="text-xs uppercase tracking-widest text-neutral-400 mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
